import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompRichTextWrapperCore } from '../core/rich-text/wrapper'
import { CompRichText } from './CompRichText'

function CompRichTextWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  return (
    <CompRichTextWrapperCore infos={infosProps}>
      {(wrapperProps) => <CompRichText {...wrapperProps} />}
    </CompRichTextWrapperCore>
  )
}


export default CompRichTextWrapper